import styled from 'styled-components';

export const OptionsStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OptionStyles = styled.div<{
  theme: 'dark-violet' | 'domination' | 'purple-gradient' | undefined;
}>`
  border-radius: 12px;
  background: #803eff12;
  backdrop-filter: blur(7.5px);
  padding: 16px;
  cursor: pointer;

  ${({ theme }) =>
    theme === 'dark-violet' &&
    `
    background: #553573;
  `}

  ${({ theme }) =>
    theme === 'domination' &&
    `
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(7.5px);
  `}
`;

export const OptionContentStyles = styled.div<{
  selected: boolean;
}>`
  height: 0;
  overflow: hidden;

  ${({ selected }) =>
    selected &&
    `
        margin: 20px 0 0;
        height: auto;
    `}
`;

export const OptionHeaderStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OptionHeaderLabelStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
